/**
 * One entry per async operation. Components read `loadingType` to tell which
 * request is in flight, not only that something is loading.
 */
export var ViewMediaFlow;
(function (ViewMediaFlow) {
    ViewMediaFlow["GET_MEDIA_FILE"] = "GetMediaFile";
})(ViewMediaFlow || (ViewMediaFlow = {}));
// What a file is shown as; one value per file even though it can carry several uses.
export var MediaFileKind;
(function (MediaFileKind) {
    MediaFileKind["UPLOADED"] = "uploaded";
    MediaFileKind["CHARACTER_AVATAR"] = "characterAvatar";
    MediaFileKind["PERSONA_AVATAR"] = "personaAvatar";
    MediaFileKind["USER_AVATAR"] = "userAvatar";
    MediaFileKind["CONVERSATION_IMAGE"] = "conversationImage";
    MediaFileKind["LOREBOOK_AVATAR"] = "lorebookAvatar";
    /** No recorded use: created but not attached to anything, so it has no type yet. */
    MediaFileKind["UNATTACHED"] = "unattached";
})(MediaFileKind || (MediaFileKind = {}));
